import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import { AuthProvider } from "@/lib/auth";
import { CountryProvider } from "@/lib/country";
import { SettingsProvider } from "@/lib/settings";

import Home from "@/pages/Home";
import Countries from "@/pages/Countries";
import CountryDetail from "@/pages/CountryDetail";
import Compare from "@/pages/Compare";
import Services from "@/pages/Services";
import Calculator from "@/pages/Calculator";
import QuickQuote from "@/pages/QuickQuote";
import CanadaIndiaLanding from "@/pages/CanadaIndiaLanding";
import CanadaIndiaThanks from "@/pages/CanadaIndiaThanks";
import Contact from "@/pages/Contact";
import Franchise from "@/pages/Franchise";
import FranchiseOpportunities from "@/pages/FranchiseOpportunities";
import FranchiseOpportunityDetail from "@/pages/FranchiseOpportunityDetail";
import TrackingScripts from "@/components/TrackingScripts";
import { CaseStudies, CaseStudyDetail } from "@/pages/CaseStudies";
import { BlogList, BlogDetail } from "@/pages/Blog";
import { Login, Register } from "@/pages/Auth";
import {
  PortalLayout, PortalDashboard, PortalProjects, PortalProjectDetail,
  PortalInvoices, PaymentSuccess,
} from "@/pages/Portal";
import {
  AdminLayout, AdminOverview, AdminLeads, AdminCountries, AdminServices,
  AdminProjects, AdminInvoices, AdminCaseStudies, AdminUsers, AdminProposals, AdminEmailLog,
} from "@/pages/Admin";
import AdminBranding from "@/pages/AdminBranding";
import AdminBlog from "@/pages/AdminBlog";
import AdminFranchise from "@/pages/AdminFranchise";
import AdminFranchiseOpps from "@/pages/AdminFranchiseOpps";
import AdminPayments from "@/pages/AdminPayments";
import AdminCountryWizard from "@/pages/AdminCountryWizard";
import AdminMarketing from "@/pages/AdminMarketing";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <CountryProvider>
            <BrowserRouter>
            <TrackingScripts />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/countries" element={<Layout><Countries /></Layout>} />
              <Route path="/countries/:slug" element={<Layout><CountryDetail /></Layout>} />
              <Route path="/open-company-in-*" element={<Layout><CountryDetail /></Layout>} />
              <Route path="/compare" element={<Layout><Compare /></Layout>} />
              <Route path="/services" element={<Layout><Services /></Layout>} />
              <Route path="/calculator" element={<Layout><Calculator /></Layout>} />
              <Route path="/quick-quote" element={<Layout><QuickQuote /></Layout>} />
              <Route path="/canada-company-india" element={<Layout><CanadaIndiaLanding /></Layout>} />
              <Route path="/canada-company-india/thank-you" element={<Layout><CanadaIndiaThanks /></Layout>} />
              <Route path="/contact" element={<Layout><Contact /></Layout>} />
              <Route path="/franchise" element={<Layout><Franchise /></Layout>} />
              <Route path="/franchise/opportunities" element={<Layout><FranchiseOpportunities /></Layout>} />
              <Route path="/franchise/opportunities/:slug" element={<Layout><FranchiseOpportunityDetail /></Layout>} />
              <Route path="/case-studies" element={<Layout><CaseStudies /></Layout>} />
              <Route path="/case-studies/:slug" element={<Layout><CaseStudyDetail /></Layout>} />
              <Route path="/blog" element={<Layout><BlogList /></Layout>} />
              <Route path="/blog/:slug" element={<Layout><BlogDetail /></Layout>} />
              <Route path="/login" element={<Layout><Login /></Layout>} />
              <Route path="/register" element={<Layout><Register /></Layout>} />
              <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />

              {/* Client portal */}
              <Route path="/portal" element={<Layout><PortalLayout /></Layout>}>
                <Route index element={<PortalDashboard />} />
                <Route path="projects" element={<PortalProjects />} />
                <Route path="projects/:id" element={<PortalProjectDetail />} />
                <Route path="invoices" element={<PortalInvoices />} />
              </Route>

              {/* Admin */}
              <Route path="/admin" element={<Layout><AdminLayout /></Layout>}>
                <Route index element={<AdminOverview />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="invoices" element={<AdminInvoices />} />
                <Route path="countries" element={<AdminCountries />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="case-studies" element={<AdminCaseStudies />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="proposals" element={<AdminProposals />} />
                <Route path="email-log" element={<AdminEmailLog />} />
                <Route path="branding" element={<AdminBranding />} />
                <Route path="franchise" element={<AdminFranchise />} />
                <Route path="franchise-opps" element={<AdminFranchiseOpps />} />
                <Route path="payments" element={<AdminPayments />} />
                <Route path="country-wizard" element={<AdminCountryWizard />} />
                <Route path="marketing" element={<AdminMarketing />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CountryProvider>
      </AuthProvider>
    </SettingsProvider>
    </div>
  );
}

export default App;
